import React, { useCallback, useMemo, useRef, useState, ForwardedRef } from 'react'
import ReactDOM from 'react-dom'
import { BaseTable } from '@jushuitan/ali-react-table'
import { Form, Pagination as AntPagination } from 'antd'
import classNames from 'classnames'
import debounce from 'lodash/debounce'
import {
    C_AFTERSALES_MANAGE,
    C_DIS_ORDER,
    C_NORMAL_ORDER,
    C_SUPPLIER_STOCK,
    C_NORMAL_GOODS,
    C_NORMAL_GOODS_SKU,
    C_NORMAL_GOODS_COMBINE,
    S_AFTERSALES_MANAGE,
    C_DIS_GOODS,
    S_DIS_GOODS,
    S_DIS_GOODS_SKU,
    S_GOODS_DISTRIBUTMANAGE_SKU,
    S_GOODS_SPEED,
    S_GOODS_SPEED_SKU,
    S_MARKETING,
    S_NORMAL_ORDER,
    S_PURCHASE_DIS_ORDER,
    S_C_SETTLEMENT_LIST,
    S_C_CREATE_AFTERSALE_ORDER_GOODSTABLE,
    S_C_CREATE_AFTERSALE_ORDER_TABLE,
    S_SUPPLIER_STOCK,
    S_DIS_GOODS_COMBINE,
    C_AFTERSALES_DISTRIBUTE_MANAGE,
    S_AFTERSALES_DISTRIBUTE_MANAGE,
    S_MY_PARTNER,
    S_C_OPERATE_ANALYSIS_SPU,
    S_C_OPERATE_ANALYSIS_SKU,
    S_C_OPERATE_ANALYSIS_SHOP,
    S_C_OPERATE_ANALYSIS_SHOP_ITEM_DETAILS,
    O_P_PAY_RISK_LIST,
    C_MY_SUPPLIER,
    S_MY_SUPPLIER,
    C_FUNDS_SUPPLIER,
    S_FUNDS_SUPPLIER,
    S_FUNDS_CHANNEL,
    O_P_SELECT_CHANNEL,
    O_P_SUPPLIER_MANAGE,
    O_P_CHANNEL_MANAGE,
    O_P_DISTIBUTE_MANAGE,
    O_P_SELECT_GOODS,
    O_P_HOT_ZONE,
    O_P_SELECT_GOODS_SUPPLIER,
    O_P_SELECT_CATEGORY,
    O_P_REFUND_LIST,
    O_P_MERCHANT_ACCOUNT_LIST,
    S_DIS_ACCOUNT_CENTER_LIST_UN_COOP,
    S_DIS_ACCOUNT_CENTER_LIST,
    S_C_SUPPLIER_ANALYSIS_LIST,
    O_P_HOT_ZONE_CATEGORY_ANALYSIS_LV1,
    O_P_HOT_ZONE_CATEGORY_ANALYSIS_LV2,
    O_P_HOT_ZONE_CATEGORY_ANALYSIS_LV3,
    S_GOODS_ONLINE_STORE_SKU,
    C_NORMAL_ONLINE_STORE_SKU,
    S_GOODS_ONLINE_STORE_STYLE,
    C_NORMAL_ONLINE_STORE_STYLE,
    DAREN_MGR_COMPANY_DAREN_DY,
    DAREN_MGR_COMPANY_DAREN_KS,
    DAREN_MGR_COMPANY_DAREN_XHS,
    DAREN_MGR_COMPANY_DAREN_WX,
    DAREN_MGR_MY_DAREN_DY,
    DAREN_MGR_MY_DAREN_KS,
    DAREN_MGR_MY_DAREN_XHS,
    DAREN_MGR_MY_DAREN_WX,
    DAREN_RETURN_SAMPLE_ORDERS,
    DAREN_USER_SAMPLE_ORDERS_DY,
    DAREN_SAMPLE_ORDERS_DY,
    DAREN_CAPTAIN_MANAGEMENT_TABLE_ID,
    DAREN_MGR_MY_DAREN_SELF,
    DAREN_MGR_COMPANY_DAREN_SELF,
    O_P_DAREN_MANAGE
} from '@/modules/globals/constants/tableKey'
import QuickSort from '@/modules/globals/components/QuickSort'
import ColumnSetting from '@/components/ProWidgets/Table/components/ColumnSetting'
import useColumnSetting from '@/components/ProWidgets/Table/hooks/useColumnSetting'
import useWindowSize from '@/hooks/useWindowSize'
import { getRootDom } from '@/utils/utils'
import Affix from './components/Affix'
import AffixV2 from './components/AffixV2'
import AntdBaseTable from './AntdBaseTable'
import type { BaseRowData, TableWWithToolbarProps } from './typings'
import styles from './index.less'

// 分页器
export const StickyFootBar = ({ left, right }: any) => {
    return (
        <div className={styles.stickyFootBar}>
            <div className={styles.lt}>{left}</div>
            <div className={styles.rt}>{right}</div>
        </div>
    )
}

// 产品需求部分放开
const WHITE_LIST = [
    C_DIS_GOODS,
    S_GOODS_SPEED,
    S_GOODS_SPEED_SKU,
    S_DIS_GOODS,
    S_DIS_GOODS_SKU,
    C_DIS_ORDER,
    S_GOODS_DISTRIBUTMANAGE_SKU,
    C_NORMAL_ORDER,
    S_PURCHASE_DIS_ORDER,
    S_C_SETTLEMENT_LIST,
    S_C_CREATE_AFTERSALE_ORDER_GOODSTABLE,
    S_C_CREATE_AFTERSALE_ORDER_TABLE,
    S_NORMAL_ORDER,
    S_MARKETING,
    S_SUPPLIER_STOCK,
    C_SUPPLIER_STOCK,
    C_AFTERSALES_MANAGE,
    S_AFTERSALES_MANAGE,
    C_NORMAL_GOODS,
    C_NORMAL_GOODS_SKU,
    C_NORMAL_GOODS_COMBINE,
    S_DIS_GOODS_COMBINE,
    C_AFTERSALES_DISTRIBUTE_MANAGE,
    S_AFTERSALES_DISTRIBUTE_MANAGE,
    S_MY_PARTNER,
    S_C_OPERATE_ANALYSIS_SPU,
    S_C_OPERATE_ANALYSIS_SKU,
    S_C_OPERATE_ANALYSIS_SHOP,
    S_C_OPERATE_ANALYSIS_SHOP_ITEM_DETAILS,
    O_P_SELECT_CHANNEL,
    O_P_SUPPLIER_MANAGE,
    O_P_CHANNEL_MANAGE,
    O_P_DISTIBUTE_MANAGE,
    O_P_DAREN_MANAGE,
    C_MY_SUPPLIER,
    S_MY_SUPPLIER,
    C_FUNDS_SUPPLIER,
    S_FUNDS_SUPPLIER,
    S_FUNDS_CHANNEL,
    O_P_SELECT_GOODS,
    O_P_PAY_RISK_LIST,
    O_P_HOT_ZONE,
    O_P_HOT_ZONE_CATEGORY_ANALYSIS_LV1,
    O_P_HOT_ZONE_CATEGORY_ANALYSIS_LV2,
    O_P_HOT_ZONE_CATEGORY_ANALYSIS_LV3,
    S_DIS_ACCOUNT_CENTER_LIST,
    O_P_SELECT_GOODS_SUPPLIER,
    O_P_SELECT_CATEGORY,
    O_P_REFUND_LIST,
    O_P_MERCHANT_ACCOUNT_LIST,
    S_DIS_ACCOUNT_CENTER_LIST_UN_COOP,
    S_C_SUPPLIER_ANALYSIS_LIST,
    S_GOODS_ONLINE_STORE_SKU,
    C_NORMAL_ONLINE_STORE_SKU,
    S_GOODS_ONLINE_STORE_STYLE,
    C_NORMAL_ONLINE_STORE_STYLE,
    DAREN_MGR_COMPANY_DAREN_DY,
    DAREN_MGR_COMPANY_DAREN_KS,
    DAREN_MGR_COMPANY_DAREN_XHS,
    DAREN_MGR_COMPANY_DAREN_WX,
    DAREN_MGR_COMPANY_DAREN_SELF,
    DAREN_MGR_MY_DAREN_DY,
    DAREN_MGR_MY_DAREN_KS,
    DAREN_MGR_MY_DAREN_XHS,
    DAREN_MGR_MY_DAREN_WX,
    DAREN_MGR_MY_DAREN_SELF,
    DAREN_RETURN_SAMPLE_ORDERS,
    DAREN_USER_SAMPLE_ORDERS_DY,
    DAREN_SAMPLE_ORDERS_DY,
    DAREN_CAPTAIN_MANAGEMENT_TABLE_ID
]
const LAZY_TIME = 800

const TABLE_HEADER_CLASS = '.art-table-header'

// eslint-disable-next-line complexity
function TableWWithToolbar<D extends BaseRowData = BaseRowData>(
    props: TableWWithToolbarProps<D>,
    ref: ForwardedRef<BaseTable>
) {
    const {
        needStickyTop = true,
        stickyTop,
        quickSortExpands,
        toolbar,
        rtPagination = null,
        rtOther,
        affix,
        columns,
        configKey,
        config: inputConfig,
        setConfig,
        dynamicSize = false,
        resetTableStickyTop,
        hasQuickSort,
        renderQuickSort,
        onChangeQuickSort,
        quickSortOption,
        userConfig,
        setUserConfig,
        currentUser,
        pagination = false,
        renderPagination = null,
        defaultConfig,
        resetConfig,
        stickyFootBarLeft = null,
        showBackTop = true,
        toolbarClassName,
        fullEmpty = null, // 空态。应用场景：没有表头但是有工具栏
        setShowBackTop,
        renderQuickSortClassName,
        tableWrapNoFixed = null, // 空态，应用场景：当需要在表格上面增加相应的显示内容，但是又不需要吸顶效果时
        transColumnConfig,
        hideColumnSettingBtn,
        hideHeader,
        defaultClickRowKey,
        columnSettingSlot,
        ...restProps
    } = props

    const config = useMemo(() => {
        if (typeof transColumnConfig === 'function') {
            return transColumnConfig(inputConfig)
        }

        return inputConfig
    }, [inputConfig])

    const transColumns = useColumnSetting({ columns, config, defaultConfig })

    const hasColumnSetting = WHITE_LIST.includes(configKey)

    const [toolbarHeight, setToolbarHeight] = useState(0)

    const { size } = useWindowSize({ dynamicSize })

    const $pipeline = useRef(null)

    const onPipeline = pipeline => {
        $pipeline.current = pipeline
    }

    const onConfigChange = (_, newConfig) => {
        // 注意：需要保留快捷查询配置！！！
        const { filters } = config

        setTimeout(() => {
            // 不想用受控模式，列宽需要应用列信息中的width，所以配置变更后需要清空组件内部存储的width信息，否则会优先使用内部存储的width
            $pipeline.current?.setStateAtKey('columnResize', undefined)
        }, 100)

        return setConfig(configKey, {
            ...newConfig,
            filters
        })
    }

    const handleSizesChange = useCallback(
        debounce(sizes => {
            if (configKey) {
                transColumns.observeSizes(sizes).subscribe(newConfig => onConfigChange(configKey, newConfig))
            }
        }, LAZY_TIME),
        [configKey, transColumns]
    )

    const elRef = useRef(null)

    const [affixed, setAffixed] = useState(false)

    // 和东哥讨论，暂时先加一个state 后续优化的时候再重构
    const [affixed2, setAffixed2] = useState(false)

    const updateTableHeaderNodeTop = ({ lastAffix, height }) => {
        const tableHeader = elRef.current?.querySelector(TABLE_HEADER_CLASS)

        if (tableHeader) {
            const top = lastAffix ? (stickyTop || 0) + (height || 0) : 0

            tableHeader.setAttribute('style', `top: ${top}px`)
        }
    }

    const affixOpts = {
        ...(affix || {}),
        offsetTop: stickyTop || 0,
        target: affix?.target ? affix.target : getRootDom,
        onChange: (e: boolean, rect: any) => {
            if (e !== affixed2 && affix?.noDefaultPadding) {
                setAffixed2(e)
            }
            if (affix?.collapsedView && e !== affixed) {
                setAffixed(e)

                if (rect) {
                    const { height } = rect || {}

                    if (height) {
                        updateTableHeaderNodeTop({
                            lastAffix: e,
                            height
                        })
                        setToolbarHeight(height)
                    }
                }
            }

            try {
                if (showBackTop) {
                    setShowBackTop?.(e)
                }
            } catch (error) {
                console.error('catchError', error)
            }
            affix?.onChange?.(e)
        },
        onSizeChange({ height }) {
            if (affix?.collapsedView) {
                updateTableHeaderNodeTop({
                    lastAffix: affixed,
                    height
                })
            }

            setToolbarHeight(Math.floor(height))
        },
        onStateChange({ height, lastAffix, collapsed }) {
            if (collapsed) {
                updateTableHeaderNodeTop({
                    lastAffix,
                    height
                })
            }
        }
    }

    const getTableStickyTop = () => {
        if (affix?.collapsedView) {
            return affixed ? (stickyTop || 0) + (toolbarHeight || 0) : 0
        }

        return needStickyTop ? (stickyTop || 0) + (toolbarHeight || 0) : 0
    }

    const tableStickyTop = getTableStickyTop()

    const Wrapper = affix?.collapsedView ? AffixV2 : Affix

    const hasHeader = toolbar || rtPagination || hasQuickSort || hasColumnSetting || rtOther
    const stickyBottomDefault = 40

    // 用于在外部渲染列配置
    const renderColumnSettingSlot = () => {
        if (columnSettingSlot) {
            const mountEl = columnSettingSlot?.hasOwnProperty?.('current')
                ? columnSettingSlot?.current
                : columnSettingSlot

            if (mountEl) {
                return ReactDOM.createPortal(
                    <ColumnSetting
                        configKey={configKey}
                        config={config}
                        defaultConfig={defaultConfig}
                        resetConfig={resetConfig}
                        columns={columns}
                        setConfig={onConfigChange}
                    />,
                    mountEl
                )
            }
        }

        return null
    }

    return (
        <div ref={elRef}>
            {hasHeader && !hideHeader ? (
                <Wrapper className={styles.affix} {...(affixOpts || {})}>
                    <div
                        className={classNames(
                            {
                                [styles.toolbar]: true,
                                [styles.affixed]: !affix?.noDefaultPadding || affixed2
                            },
                            toolbarClassName
                        )}
                        id="AntdBaseTableToolbar"
                    >
                        {/* 包一下Form 为了统一样式 */}
                        <div
                            className={classNames(styles.lt, {
                                [styles.smallSize]: size === 'small'
                            })}
                        >
                            <Form size={size}>{toolbar}</Form>
                        </div>
                        {rtPagination || hasQuickSort || hasColumnSetting || rtOther ? (
                            <div className={classNames(styles.rt, 'tableWWithToolbarHeaderRt')}>
                                {rtPagination}
                                {hasQuickSort ? (
                                    <div
                                        className={classNames(
                                            styles.quickSort,
                                            styles.margin8,
                                            renderQuickSortClassName
                                        )}
                                    >
                                        {renderQuickSort ? (
                                            renderQuickSort()
                                        ) : (
                                            <QuickSort
                                                configKey={configKey}
                                                quickSortExpands={quickSortExpands}
                                                onChangeQuickSort={onChangeQuickSort}
                                                sortOption={quickSortOption}
                                                userConfig={userConfig}
                                                setUserConfig={setUserConfig}
                                                currentUser={currentUser}
                                            />
                                        )}
                                    </div>
                                ) : null}
                                {/* 快速排序 */}

                                {hasColumnSetting && !hideColumnSettingBtn ? (
                                    <div className={classNames(styles.margin8)}>
                                        <ColumnSetting
                                            configKey={configKey}
                                            config={config}
                                            defaultConfig={defaultConfig}
                                            resetConfig={resetConfig}
                                            columns={columns}
                                            setConfig={onConfigChange}
                                        />
                                    </div>
                                ) : null}
                                {/* 其他 */}
                                {rtOther}
                            </div>
                        ) : null}
                    </div>
                </Wrapper>
            ) : null}
            {tableWrapNoFixed}
            {renderColumnSettingSlot()}
            {fullEmpty || (
                <>
                    <AntdBaseTable
                        ref={ref}
                        stickyTop={typeof resetTableStickyTop === 'number' ? resetTableStickyTop : tableStickyTop}
                        stickyBottom={pagination || renderPagination ? stickyBottomDefault : undefined}
                        columns={transColumns.columns}
                        defaultClickRowKey={defaultClickRowKey}
                        onPipeline={onPipeline}
                        onChangeSizes={handleSizesChange}
                        {...restProps}
                    />

                    {pagination || renderPagination ? (
                        <StickyFootBar
                            left={stickyFootBarLeft}
                            right={renderPagination ? renderPagination : <AntPagination size="small" {...pagination} />}
                        />
                    ) : null}
                </>
            )}
        </div>
    )
}

export default React.memo(React.forwardRef<BaseTable, TableWWithToolbarProps>(TableWWithToolbar))
